// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CompanyReviews_wrapper__q4ilx"};